// extracted by mini-css-extract-plugin
module.exports = {"Owner":"Comment_Owner__3sgYe","Date":"Comment_Date__10qt0"};